<div class="summary" appConfigSettingsParagraph>
  <div class="summary-header">
    <h2 appConfigSettingsSecondTitle>{{'ApplicationPage.ClosingStatement' | translate}}</h2>
  </div>
  <div class="summary-statements">
    <div class="summary-statements-title">
      {{'ClosingStatement.WhoDeclare' | translate}}
    </div>
    <div class="summary-statements-bullets">
      <ul>
        <li class="SummaryBullets">{{'ClosingStatement.Bullet1' | translate}}</li>
        <li class="SummaryBullets">{{'ClosingStatement.Bullet2' | translate}}</li>
        <li class="SummaryBullets">
          <div>
            {{'ClosingStatement.Bullet3.0' | translate }}
            <a target="_blank" href="https://www.taf.nl/algemeen/privacy-statement">
              {{'ClosingStatement.Bullet3.1' | translate }}
            </a>
            {{'ClosingStatement.Bullet3.2' | translate }}
          </div>
        </li>
        <li class="SummaryBullets">{{'ClosingStatement.Bullet4' | translate}}</li>
        <li class="SummaryBullets">{{'ClosingStatement.Bullet5' | translate}}</li>
        <li class="SummaryBullets">{{parseTemplatedStatement('ClosingStatement.Bullet6', 'policy_terms')}}</li>
        <li class="SummaryBullets">{{parseTemplatedStatement('ClosingStatement.Bullet7', 'name_intermediary')}}</li>
        <li class="SummaryBullets" *ngIf="getTextFor8Paragraph()">{{getTextFor8Paragraph()}}</li>
        <li class="SummaryBullets" *ngIf="getTextForFinalStatementAddition()" [innerHTML]="getTextForFinalStatementAddition()"></li>
      </ul>
      <div class="buttons-wrapper buttons-wrapper-vertical">
        <div>
          <app-checkbox-input
            placeholder="ClosingStatement.CheckBox"
            [form]="formGroup"
            [control]="formGroup.get('isAgreed')"
          ></app-checkbox-input>
          <app-notification-block
            class="summary-notification-block"
            [notification]="notificationEvent"
          ></app-notification-block>
        </div>
        <div class="buttons-row">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            class="primary submitApplicationBtn"
            (click)="submitApplication()"
            [disabled]="false"
            [style.color]="formGroup.get('isAgreed').value ? configSettings.backgroundColor : configSettings.backgroundTextColor"
            [style.background]="formGroup.get('isAgreed').value ? configSettings.backgroundTextColor : configSettings.backgroundColor"
            [style.border]="formGroup.get('isAgreed').value ? 'none' : 'solid 1px ' + configSettings.backgroundTextColor"
          >
            {{'ApplicationPage.Apply' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="summary-premium-block">
    <app-premium-block
      [isMobile]="true"
      [checkIsPremiumsCalculated]="false"
      [isStatementsAgreed]="formGroup.get('isAgreed').value"
      (submitEvent)="submitApplication()"
      [productType]="productType"
      [showControlsBlock]="true"
    ></app-premium-block>
  </div>
</div>
